import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Row from 'ravenjs/lib/Row';
import Typography from 'ravenjs/lib/Typography';
import { formatNumberWithDelimiter } from 'ravenjs/utils/number';
import { themeGet } from 'ravenjs/utils/theme';
import PaginationTotalRowsV2 from './PaginationTotalRowsV2';

const PaginationTotalRowsStyled = styled(Row)`
    /**
     * Add all of the remaining styles from theme
     */
    ${themeGet('PaginationTotalRows.styles')};
`;

function PaginationTotalRows(props) {
    const { totalRows, usePaginationV2 } = props;
    const total = formatNumberWithDelimiter(totalRows || 0);

    if (usePaginationV2) {
        return <PaginationTotalRowsV2 {...props} />;
    }

    return (
        <PaginationTotalRowsStyled
            alignItems="center"
            gutter={false}
            justify="flex-start"
            width="auto"
        >
            <Typography
                color="text"
                fontSize="0.75rem"
                fontFamily="RobotoMono"
                gutterBottom="0"
                gutterRight="4px"
                gutterTop="0"
                type="paginationLabel"
            >
                {total} RESULTS
            </Typography>
        </PaginationTotalRowsStyled>
    );
}

PaginationTotalRows.propTypes = {
    /**
     * The number of total rows.
     */
    totalRows: PropTypes.number,
    /**
     * Whether to use a custom total rows label.
     */
    usePaginationV2: PropTypes.bool,
};

PaginationTotalRows.defaultProps = {
    totalRows: 0,
    usePaginationV2: false,
};

export default PaginationTotalRows;
